import React from 'react';

export const PaymentLoader=({loading})=>{
        return (
            <div className='loader-accounts'>
                <div className='loader'></div>
            </div>
        );
}